require('./bootstrap');

import CitySelectorModal  from './components/city-selector-modal';
import Services from "./components/services";

import ButtonHandler from "./components/button-handler";
import ModalHandler from "./components/modal-handler";
import CityCheck from './components/city-check';

import About from "./components/about"; // bug
import {gobletPopover, aboutPopover} from "./components/popovers"; // bug

import FooterMenu from "./components/footer-menu";

import SomeStuff from "./components/some-stuff";

const citySelector = new CitySelectorModal(); // vanilla
const services = new Services(); // vanilla
const buttonHandler = new ButtonHandler(); // vanilla
const modalHandler = new ModalHandler(); // vanilla
const cityCheck = new CityCheck(); // vanilla // vanilla
const about = new About(); // bug // vanilla
const footer = new FooterMenu(); // vanilla
const someStuff = new SomeStuff(); // vanilla
gobletPopover(); // vanilla
aboutPopover(); // vanilla


